import { createContext } from 'react';

interface WebsiteContextType {
    params: {
        siteId: string;
        name: string;
    };
    pathName: string;
    lang: string;
    adsConfig: any;
}

export const WebSiteContext = createContext<WebsiteContextType>({
    params: {
        siteId: '',
        name: '',
    },
    pathName: '',
    lang: 'en',
    adsConfig: null,
});
